import React, { useEffect, useState } from 'react';
import { AlertCircle, X } from 'lucide-react';

/**
 * VoicePrivacyNotice
 * One-time inline notice shown on each phase intro before the client first
 * uses the microphone. Dismissal is persisted in localStorage so the banner
 * only appears once per browser.
 *
 * Wording is fixed to match the copy shown in the Privacy Policy so both
 * surfaces communicate the same guarantee.
 */
const STORAGE_KEY = 'voice_privacy_notice_ack_v1';

export const VOICE_PRIVACY_STATEMENT =
  'Your voice is processed on your device to create text. No audio is recorded or stored.';

const VoicePrivacyNotice = ({ className = '', testId }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const ack = window.localStorage.getItem(STORAGE_KEY);
      if (!ack) setVisible(true);
    } catch (e) { /* ignore */ }
  }, []);

  const dismiss = () => {
    try { window.localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (e) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={`mx-auto max-w-2xl mb-4 flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 p-3 text-left ${className}`}
      data-testid={testId || 'voice-privacy-notice'}
      role="status"
      aria-live="polite"
    >
      <AlertCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm text-blue-900">{VOICE_PRIVACY_STATEMENT}</p>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss privacy notice"
        className="text-blue-500 hover:text-blue-800 transition-colors"
        data-testid="voice-privacy-notice-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default VoicePrivacyNotice;
